module.exports = __webpack_public_path__ + "media/images/PB_Digiteer_Banner-13c50a401a952ae84b49b37c3402403b.jpg";